export interface VttCue {
  time: string
  speaker: string
  text: string
}

const TIMESTAMP_RE = /(\d{1,2}:\d{2}(?::\d{2})?(?:[.,]\d{1,3})?)\s*-->\s*(\d{1,2}:\d{2}(?::\d{2})?(?:[.,]\d{1,3})?)/g

function formatStart(raw: string): string {
  const parts = raw.split(':')
  if (parts.length === 3) {
    const h = parseInt(parts[0], 10)
    const m = parts[1]
    const s = parts[2].split(/[.,]/)[0]
    return h > 0 ? `${h}:${m}:${s}` : `${parseInt(m, 10)}:${s}`
  }
  if (parts.length === 2) {
    return `${parseInt(parts[0], 10)}:${parts[1].split(/[.,]/)[0]}`
  }
  return raw
}

export function parseVtt(raw: string): VttCue[] {
  if (!raw) return []
  const normalized = raw.replace(/\r\n/g, '\n').replace(/\r/g, '\n')

  TIMESTAMP_RE.lastIndex = 0
  const matches: { start: string; index: number; endOfMatch: number }[] = []
  let m: RegExpExecArray | null
  while ((m = TIMESTAMP_RE.exec(normalized)) !== null) {
    matches.push({ start: m[1], index: m.index, endOfMatch: m.index + m[0].length })
  }
  if (matches.length === 0) return []

  const cues: VttCue[] = []
  for (let i = 0; i < matches.length; i++) {
    const cur = matches[i]
    const nextStart = i + 1 < matches.length ? matches[i + 1].index : normalized.length
    let body = normalized.slice(cur.endOfMatch, nextStart)
    body = body.replace(/\s+\d{1,6}\s*$/, '').trim()
    if (!body) continue

    body = body.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim()

    let speaker = ''
    let text = body

    const vMatch = text.match(/^<v\s+([^>]+)>([\s\S]*)$/i)
    if (vMatch) {
      speaker = vMatch[1].trim()
      text = vMatch[2].replace(/<[^>]+>/g, '').trim()
    } else {
      const sMatch = text.match(/^([A-Za-z][A-Za-z .'\-]{0,40}?):\s*(.+)$/)
      if (sMatch) {
        speaker = sMatch[1].trim()
        text = sMatch[2].trim()
      }
    }

    if (text) cues.push({ time: formatStart(cur.start), speaker, text })
  }

  return cues
}
